import { fabric } from 'fabric';

const Rectangle = fabric.util.createClass(fabric.Rect, {
  type: 'square',

  initialize(element, options) {
    options || (options = {});
    this.callSuper('initialize', element, options);

    // Set default options
    this.set({
      rotateAngle: 0,
      hasRotatingPoint: false,
      radius: 100,
      opacity: 0.3,
    });
  },

  toObject() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      customProps: this.customProps,
      rotateAngle: this.angle,
    });
  },
});

export default Rectangle;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Items/Rectangle.js